(function () {
  'use strict';

  /* The UGC Videos section reuses this carousel and loads this file itself, so
     a page carrying both sections evaluates it twice — which would bind every
     listener twice over. Both script tags are deferred, so whichever runs first
     already sees every section in the DOM and wires all of them. */
  if (window.__odditTestimonialsCarouselInit) return;
  window.__odditTestimonialsCarouselInit = true;

  var SECTION_SELECTOR = '.oddit-section-testimonials';
  var TRACK_SELECTOR = '.oddit-section-testimonials__track';
  var DOT_SELECTOR = '.oddit-section-testimonials__dot';
  var DOT_ACTIVE_CLASS = 'oddit-section-testimonials__dot--active';
  var CARD_SELECTOR = '.oddit-section-testimonials__card';
  var PAGINATION_SELECTOR = '.oddit-section-testimonials__pagination';

  function initSection(section) {
    var track = section.querySelector(TRACK_SELECTOR);
    var dots = section.querySelectorAll(DOT_SELECTOR);

    if (!track || !dots.length) return;

    var dotCount = dots.length;
    var cards = section.querySelectorAll(CARD_SELECTOR);
    var pagination = section.querySelector(PAGINATION_SELECTOR);
    var rafId = null;
    var resizeRaf = null;

    /**
     * How many cards fit in the visible track. Measured rather than assumed,
     * since the count is CSS-driven and changes across breakpoints.
     */
    function getCardsPerPage() {
      if (cards.length < 2) return 1;
      var step = cards[1].offsetLeft - cards[0].offsetLeft;
      if (!step || step <= 0) step = cards[0].offsetWidth;
      if (!step || step <= 0) return 1;

      var styles = getComputedStyle(track);
      var inner =
        track.clientWidth -
        (parseFloat(styles.paddingLeft) || 0) -
        (parseFloat(styles.paddingRight) || 0);

      var fit = Math.round(inner / step);
      return Math.min(cards.length, Math.max(1, fit));
    }

    function getPageCount() {
      return Math.max(1, Math.ceil(cards.length / getCardsPerPage()));
    }

    /**
     * One dot per page of visible cards, not per card. Liquid renders one dot
     * per card as the upper bound; the surplus is hidden once the fit can be
     * measured, and the whole control is hidden when there is a single page.
     */
    function syncDotCount() {
      var pages = getPageCount();
      for (var i = 0; i < dotCount; i++) {
        var used = i < pages;
        dots[i].hidden = !used;
        dots[i].style.display = used ? '' : 'none';
        dots[i].setAttribute('aria-label', 'Go to slide ' + (i + 1) + ' of ' + pages);
      }
      if (pagination) pagination.hidden = pages < 2;
      return pages;
    }

    function getActiveIndex() {
      var perPage = getCardsPerPage();
      var padding = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      var current = 0;
      var bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs(track.scrollLeft - (cards[i].offsetLeft - padding));
        if (dist < bestDist) {
          bestDist = dist;
          current = i;
        }
      }
      return Math.min(getPageCount() - 1, Math.max(0, Math.floor(current / perPage)));
    }

    function updateDots() {
      var activeIndex = getActiveIndex();
      for (var i = 0; i < dotCount; i++) {
        if (i === activeIndex) {
          dots[i].classList.add(DOT_ACTIVE_CLASS);
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].classList.remove(DOT_ACTIVE_CLASS);
          dots[i].removeAttribute('aria-current');
        }
      }
    }

    function handleScroll() {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        updateDots();
      });
    }

    function handleDotClick(e) {
      var btn = e.currentTarget;
      var index = parseInt(btn.getAttribute('data-slide-index'), 10);
      if (isNaN(index) || index < 0 || index >= dotCount) return;

      /* Scroll to the first card of that page, clamped to the last card. */
      var perPage = getCardsPerPage();
      var cardIndex = Math.min(cards.length - 1, index * perPage);
      var targetCard = cards[cardIndex];
      if (!targetCard) return;

      var padding = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      track.scrollTo({ left: targetCard.offsetLeft - padding, behavior: 'smooth' });
    }

    function handleResize() {
      if (resizeRaf) return;
      resizeRaf = requestAnimationFrame(function () {
        /* Before the dot maths, which divides by how many cards fit and so
           depends on the padding this sets. */
        centreTrack();
        resizeRaf = null;
        syncDotCount();
        updateDots();
      });
    }

    /* ---- Video modal ----
       The play button was decorative: no handler, and the section had no video
       setting at all. Blocks now carry a YouTube/Vimeo URL and the button opens
       it in a shared dialog. src is assigned on open and cleared on close, so
       closing actually stops playback rather than leaving audio running. */
    (function initVideo() {
      var modal = section.querySelector('[data-video-modal]');
      var iframe = section.querySelector('[data-video-iframe]');
      if (!modal || !iframe) return;

      var lastTrigger = null;

      function open(src, trigger) {
        lastTrigger = trigger || null;
        iframe.src = src;
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var closeBtn = modal.querySelector('[data-video-close]');
        if (closeBtn) closeBtn.focus();
      }

      function close() {
        modal.hidden = true;
        iframe.src = '';
        document.documentElement.style.overflow = '';
        if (lastTrigger) lastTrigger.focus();
      }

      var plays = section.querySelectorAll('[data-video-play]');
      for (var p = 0; p < plays.length; p++) {
        plays[p].addEventListener('click', function (e) {
          e.preventDefault();
          var src = this.getAttribute('data-video-src');
          if (src) open(src, this);
        });
      }

      var closers = modal.querySelectorAll('[data-video-close]');
      for (var c = 0; c < closers.length; c++) {
        closers[c].addEventListener('click', close);
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
      });
    })();

    /* ---- Centring ----
       See the note on --oddit-testimonials-gutter in the stylesheet. Fit as many
       whole cards as the section holds, then split the remainder between the two
       edges, so the space before the first card matches the space after the last
       whole one — which is also what turns the sliver of a 5th card at the right
       edge into a proper peek.

       Desktop only. Below 990px the gutter is a flat 16/40px design inset rather
       than the column arithmetic that causes the offset, and re-deriving it there
       would move the heading for no reason. */
    var desktop = window.matchMedia('(min-width: 990px)');

    function centreTrack() {
      if (!desktop.matches) {
        section.style.removeProperty('--oddit-testimonials-gutter');
        return;
      }
      if (cards.length < 1) return;

      var cardWidth = cards[0].offsetWidth;
      if (cardWidth <= 0) return;

      var step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cardWidth;
      if (step <= 0) step = cardWidth;

      var gap = step - cardWidth;
      var available = track.clientWidth;
      /* +gap because a run of N cards carries N-1 gaps, not N. */
      var fit = Math.max(1, Math.floor((available + gap) / step));
      var gutter = (available - (fit * step - gap)) / 2;

      /* A floor, because this gutter also insets the heading. At some widths the
         cards very nearly fill the section — 1920px fits five with 32px over —
         and a heading pinned 32px from the screen edge reads as a mistake even
         though the cards below it are perfectly centred. Where the floor binds
         the run is a few pixels off centre, which is the cheaper of the two. */
      gutter = Math.max(40, gutter);

      section.style.setProperty('--oddit-testimonials-gutter', Math.round(gutter) + 'px');
    }

    track.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleResize, { passive: true });

    for (var i = 0; i < dotCount; i++) {
      dots[i].addEventListener('click', handleDotClick);
    }

    section._odditTestimonials = {
      destroy: function () {
        track.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleResize);
        for (var j = 0; j < dotCount; j++) {
          dots[j].removeEventListener('click', handleDotClick);
        }
        if (rafId) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
        if (resizeRaf) {
          cancelAnimationFrame(resizeRaf);
          resizeRaf = null;
        }
      }
    };

    centreTrack();
    /* A measurement taken before the cards are laid out reads a zero width and
       bails, leaving the fallback gutter for good — nothing else re-measures
       until a resize. */
    if (document.readyState !== 'complete') {
      window.addEventListener('load', function () {
        requestAnimationFrame(centreTrack);
      }, { once: true });
    }

    syncDotCount();
    updateDots();
  }

  function destroySection(section) {
    if (section._odditTestimonials) {
      section._odditTestimonials.destroy();
      delete section._odditTestimonials;
    }
  }

  /* Init all instances on page */
  var sections = document.querySelectorAll(SECTION_SELECTOR);
  for (var k = 0; k < sections.length; k++) {
    initSection(sections[k]);
  }

  /* Shopify theme editor lifecycle */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();